var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'v-inline',
    `v-inline--${_vm.size}`,
    _vm.contentAlignment && `v-inline--${_vm.contentAlignment}`
  ]},[_c('div',{staticClass:"v-inline__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }